import React from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../../../components/admin/AdminLayout';

function AdminSiteHome() {
  return (
    <AdminLayout title="">
      <h1 style={{ marginTop: 0 }}>Site</h1>
      <p>Gérez le contenu du site public.</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px,1fr))', gap: 16, marginTop: 16 }}>
        <div className="card">
          <h3>Accueil</h3>
          <p>Slider, sections, contenus de la home.</p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Link to="/admin/site/accueil/slider">Slider</Link>
            <Link to="/admin/site/accueil/sections">Sections</Link>
          </div>
        </div>
        <div className="card">
          <h3>Réalisations</h3>
          <p>Projets, catégories, images.</p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Link to="/admin/site/realisations">Réalisations</Link>
            <Link to="/admin/site/realisations/categories">Catégories</Link>
          </div>
        </div>
        <div className="card">
          <h3>Tarifs</h3>
          <p>Plans et options.</p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Link to="/admin/site/tarifs">Tableau de bord</Link>
            <Link to="/admin/site/tarifs/plans">Plans</Link>
            <Link to="/admin/site/tarifs/options">Options</Link>
            <Link to="/admin/site/tarifs/comparatif">Comparatif</Link>
            <Link to="/admin/site/tarifs/details">Détails</Link>
          </div>
        </div>
        <div className="card">
          <h3>Contact</h3>
          <p>Coordonnées et messages reçus.</p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Link to="/admin/site/contact">Tableau de bord</Link>
            <Link to="/admin/site/contact/reglages">Réglages</Link>
            <Link to="/admin/site/contact/messages">Messages</Link>
          </div>
        </div>
        <div className="card">
          <h3>Promotions</h3>
          <p>Bandeau promo sous la navbar + tagline.</p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Link to="/admin/site/annonces">Ouvrir</Link>
          </div>
        </div>
        <div className="card">
          <h3>Taglines</h3>
          <p>Messages de la tagline (rotation automatique).</p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Link to="/admin/site/taglines">Ouvrir</Link>
          </div>
        </div>
        <div className="card">
          <h3>Effets Visuels</h3>
          <p>Saisonniers (Neige, Pluie, etc).</p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Link to="/admin/site/effets">Gérer</Link>
          </div>
        </div>
        <div className="card">
          <h3>Blog</h3>
          <p>Articles, catégories, publication.</p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Link to="/admin/site/blog/articles">Articles</Link>
            <Link to="/admin/site/blog/categories">Catégories</Link>
          </div>
        </div>
        <div className="card">
          <h3>Équipe</h3>
          <p>Membres affichés sur la page “À propos”.</p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <Link to="/admin/site/equipe">Ouvrir</Link>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}

export default AdminSiteHome;
